module.exports = __webpack_public_path__ + "media/iconic/briefcase-a452266e.svg";